import React, { useState } from "react";
import TopHeader from "./nav_top.js";
import FuturesTradeTable from "./_63_futures_table.js";
import "./styles.css";

const MODULE_NAME = "pg_options";

const FuturesPage = () => {
  // Read userId from sessionStorage, fallback to 1 if not set or invalid
  const storedId = sessionStorage.getItem("user_id");
  const userId = storedId && !isNaN(Number(storedId)) ? Number(storedId) : 1;

  const activeDate = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  const initialScreen = "pg_options";

  const [screen, setScreen] = useState(initialScreen);
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <>
      <TopHeader 
        userId={userId} 
        screen={screen} 
        refreshKey={refreshKey}
        onNavigate={setScreen}
      />
          <FuturesTradeTable userId={userId} activeDate={activeDate} screen={screen} refreshKey={refreshKey} />
    </>
  );
};

export default FuturesPage;